import { render, staticRenderFns } from "./CommunicationsPortal.vue?vue&type=template&id=69a8c2bd&scoped=true&"
import script from "./CommunicationsPortal.vue?vue&type=script&lang=js&"
export * from "./CommunicationsPortal.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationsPortal.vue?vue&type=style&index=0&id=69a8c2bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a8c2bd",
  null
  
)

export default component.exports